var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticStyle: { "padding-left": "22px" },
                      attrs: { lg: "2" }
                    },
                    [
                      _c(
                        "a",
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("WORKFLOW.DOCUMENT_TYPE")) + " "
                          ),
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*")
                          ]),
                          _vm._v(" "),
                          !_vm.isRotatedDoc
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.viewport",
                                      modifiers: { hover: true, viewport: true }
                                    }
                                  ],
                                  staticClass: "btn btn-primary btn-sm",
                                  staticStyle: {
                                    "margin-left": "5px",
                                    "border-radius": "6px",
                                    "margin-bottom": "5px"
                                  },
                                  attrs: { variant: "secondary" },
                                  on: {
                                    mouseover: function($event) {
                                      _vm.showTooltip = true
                                    },
                                    mouseout: function($event) {
                                      _vm.showTooltip = false
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-info-circle" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showTooltip
                            ? _c("div", { staticClass: "custom-tooltip" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../static/img/templateimg.png")
                                  }
                                }),
                                _vm._v(" "),
                                _c("h5", [
                                  _c("p", [
                                    _vm._v(
                                      "Step 1 - Determine the document category that matches the Start form/HIPAA consent version."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Step 2 - Select the thumbnail image representing this particular document."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Step 3 - Next, scroll down to the bottom of the page to find and make a note of the Map ID linked to this form."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Step 4 - Following that, check the checkbox adjacent to SF/HIPAA and confirm that the document category matches the MAP ID of SF/HIPAA."
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          plain: true,
                          options: _vm.setFormTypeOptions,
                          disabled: _vm.isRotatedDoc,
                          placeholder: "Select Document Type"
                        },
                        on: { change: _vm.disableCheckboxOnEditedDoc },
                        model: {
                          value: _vm.formType,
                          callback: function($$v) {
                            _vm.formType = $$v
                          },
                          expression: "formType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("div", { staticClass: "loading-overlay" }, [
                        _c("div", { staticClass: "loading-spinner" })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticStyle: { "margin-top": "27px" },
                      attrs: { lg: "5" }
                    },
                    [
                      !_vm.isRotatedDoc
                        ? _c(
                            "b-button",
                            {
                              staticClass: "addGroupBtn",
                              staticStyle: {
                                "margin-bottom": "5px",
                                "padding-bottom": "0px",
                                "border-radius": "6px",
                                height: "40px",
                                "margin-top": "0px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                size: "sm",
                                variant: "secondary",
                                disabled:
                                  _vm.disableSaveButton ||
                                  this.editAttachmentsEnabled !== null
                              },
                              on: { click: _vm.CheckboxSave }
                            },
                            [_c("span", [_c("h5", [_vm._v("Save")])])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isRotatedDoc
                        ? _c(
                            "b-button",
                            {
                              staticClass: "addGroupBtn",
                              staticStyle: {
                                "margin-bottom": "5px",
                                "padding-bottom": "0px",
                                "border-radius": "6px",
                                height: "40px",
                                "margin-top": "0px",
                                "margin-right": "5px"
                              },
                              attrs: { size: "sm", variant: "secondary" },
                              on: {
                                click: function($event) {
                                  _vm.clearEditedAttachedPages()
                                  _vm.CheckboxClear()
                                }
                              }
                            },
                            [_c("span", [_c("h5", [_vm._v("Reset")])])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isRotatedDoc
                        ? _c(
                            "b-button",
                            {
                              staticClass: "addGroupBtn",
                              staticStyle: {
                                "margin-bottom": "5px",
                                "padding-bottom": "0px",
                                "border-radius": "6px",
                                height: "40px",
                                "margin-top": "0px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                size: "sm",
                                variant: "secondary",
                                disabled:
                                  _vm.processButtonDisabled ||
                                  this.editAttachmentsEnabled !== null ||
                                  Object.keys(_vm.selectedTitleDocs).length <=
                                    0 ||
                                  _vm.isEditedDoc
                              },
                              on: {
                                click: function($event) {
                                  _vm.doProcess("OCR")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _c("h5", [
                                  _vm._v("Process With OCR "),
                                  _vm.processButtonDisabled
                                    ? _c("i", {
                                        staticClass:
                                          "fa fa-spinner fa-spin mr-2",
                                        staticStyle: { "font-size": "16px" }
                                      })
                                    : _vm._e(),
                                  _c("span")
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isRotatedDoc
                        ? _c(
                            "b-button",
                            {
                              staticClass: "addGroupBtn",
                              staticStyle: {
                                "margin-bottom": "5px",
                                "padding-bottom": "0px",
                                "border-radius": "6px",
                                height: "40px",
                                "margin-top": "0px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                size: "sm",
                                variant: "secondary",
                                disabled:
                                  _vm.processButtonDisabled ||
                                  this.editAttachmentsEnabled !== null ||
                                  Object.keys(_vm.selectedTitleDocs).length <=
                                    0 ||
                                  _vm.isEditedDoc
                              },
                              on: {
                                click: function($event) {
                                  _vm.doProcess("AI")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _c("h5", [
                                  _vm._v("Process With AI "),
                                  _vm.processButtonDisabled
                                    ? _c("i", {
                                        staticClass:
                                          "fa fa-spinner fa-spin mr-2",
                                        staticStyle: { "font-size": "16px" }
                                      })
                                    : _vm._e(),
                                  _c("span")
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isRotatedDoc
                        ? _c(
                            "b-button",
                            {
                              staticClass: "addGroupBtn",
                              staticStyle: {
                                "margin-bottom": "5px",
                                "padding-bottom": "0px",
                                "border-radius": "6px",
                                height: "40px",
                                "margin-top": "0px",
                                "margin-right": "5px"
                              },
                              attrs: { size: "sm", variant: "secondary" },
                              on: { click: _vm.exportRotatedDoc }
                            },
                            [
                              _c("span", [
                                _c("h5", [
                                  _vm._v("Export "),
                                  _vm.processButtonDisabled
                                    ? _c("i", {
                                        staticClass:
                                          "fa fa-spinner fa-spin mr-2",
                                        staticStyle: { "font-size": "16px" }
                                      })
                                    : _vm._e(),
                                  _c("span")
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "addGroupBtn",
                          staticStyle: {
                            "margin-bottom": "5px",
                            "padding-bottom": "0px",
                            "border-radius": "6px",
                            height: "40px",
                            "margin-top": "0px",
                            "margin-right": "5px"
                          },
                          attrs: { size: "sm", variant: "secondary" },
                          on: { click: _vm.showRejectFormModal }
                        },
                        [
                          _c("span", [
                            _c("h5", [
                              _vm._v("Reject "),
                              _c("i", { staticStyle: { "font-size": "16px" } }),
                              _c("span")
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "addGroupBtn",
                          staticStyle: {
                            "margin-bottom": "5px",
                            "padding-bottom": "0px",
                            "border-radius": "6px",
                            height: "40px",
                            "margin-top": "0px",
                            "margin-right": "5px"
                          },
                          attrs: { size: "sm", variant: "secondary" },
                          on: {
                            click: function($event) {
                              _vm.rotateSelectedImgs(-90)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _c("h5", [
                              _vm._v("Rotate Left"),
                              _c("i", { staticStyle: { "font-size": "16px" } }),
                              _c("span")
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "addGroupBtn",
                          staticStyle: {
                            "margin-bottom": "5px",
                            "padding-bottom": "0px",
                            "border-radius": "6px",
                            height: "40px",
                            "margin-top": "0px",
                            "margin-right": "5px"
                          },
                          attrs: { size: "sm", variant: "secondary" },
                          on: {
                            click: function($event) {
                              _vm.rotateSelectedImgs(+90)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _c("h5", [
                              _vm._v("Rotate Right"),
                              _c("i", { staticStyle: { "font-size": "16px" } }),
                              _c("span")
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [_c("b-row", [_c("b-col", { attrs: { lg: "3" } })], 1)],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticStyle: { padding: "10px" } },
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                {
                  staticStyle: { "overflow-y": "scroll", height: "60vh" },
                  attrs: { sm: "6" }
                },
                [
                  _vm.isRotatedDoc
                    ? _c("div", { staticClass: "notes-margin" }, [
                        _c("ul", [
                          _c("h5", { staticStyle: { "font-weight": "bold" } }, [
                            _vm._v("Note:")
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "Kindly choose an image and adjust its orientation as needed."
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "After rotating the pages, hit Export to see the whole document with the changes in Salesforce."
                            )
                          ])
                        ])
                      ])
                    : _c(
                        "div",
                        [
                          _c("b-col", { attrs: { lg: "6" } }, [
                            _c("h5", [_vm._v("Triaged Documents")])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { lg: "6" } }),
                          _vm._v(" "),
                          _c("b-col", { attrs: { lg: "12" } }, [
                            _c(
                              "table",
                              {
                                staticClass: "result",
                                staticStyle: { width: "100%" }
                              },
                              [
                                _c(
                                  "tr",
                                  {
                                    staticClass: "result",
                                    staticStyle: {
                                      "background-color": "rgb(168 174 179)",
                                      "font-size": "12px"
                                    }
                                  },
                                  [
                                    !_vm.isRotatedDoc
                                      ? _c("th", { staticClass: "result" }, [
                                          _vm._v(" Document Type ")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "result" }, [
                                      _vm._v(" Page Number(s) ")
                                    ]),
                                    _vm._v(" "),
                                    !_vm.isRotatedDoc
                                      ? _c("th", { staticClass: "result" }, [
                                          _vm._v(" Attached"),
                                          _c("br"),
                                          _vm._v(" Page Number(s) ")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isRotatedDoc
                                      ? _c("th", { staticClass: "result" }, [
                                          _vm._v(" Insurance Card"),
                                          _c("br"),
                                          _vm._v(" Page Number(s) ")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "result" }, [
                                      _vm._v(" Action ")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.selectedTitleDocs, function(
                                  value,
                                  key
                                ) {
                                  return _c(
                                    "tr",
                                    {
                                      class: _vm.getResultCss(value),
                                      staticStyle: { "font-size": "12px" }
                                    },
                                    [
                                      !_vm.isRotatedDoc
                                        ? _c("td", { staticClass: "result" }, [
                                            _vm._v(
                                              _vm._s(value.template_doc.text)
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "result" }, [
                                        _vm._v(_vm._s(value.pages.join(", ")))
                                      ]),
                                      _vm._v(" "),
                                      !_vm.isRotatedDoc
                                        ? _c(
                                            "td",
                                            { staticClass: "result" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    value.attachment_pages &&
                                                      value.attachment_pages.join(
                                                        ", "
                                                      )
                                                  ) +
                                                  "\n                  "
                                              ),
                                              value.attachment_pages &&
                                              value.attachment_pages.join(", ")
                                                ? _c("br")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              value.attachment_pages &&
                                              value.attachment_pages.length > 0
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-tooltip",
                                                          rawName:
                                                            "v-b-tooltip.hover.viewport",
                                                          modifiers: {
                                                            hover: true,
                                                            viewport: true
                                                          }
                                                        }
                                                      ],
                                                      staticStyle: {
                                                        "border-radius": "5px",
                                                        padding:
                                                          "0px 3px 0px 3px"
                                                      },
                                                      attrs: {
                                                        variant: "secondary",
                                                        title:
                                                          "Remove Attachments"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.removeAttachments(
                                                            value,
                                                            key
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              value.attachment_pages &&
                                              value.attachment_pages.length > 0
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-tooltip",
                                                          rawName:
                                                            "v-b-tooltip.hover.viewport",
                                                          modifiers: {
                                                            hover: true,
                                                            viewport: true
                                                          }
                                                        }
                                                      ],
                                                      staticStyle: {
                                                        "border-radius": "5px",
                                                        padding:
                                                          "0px 3px 0px 3px"
                                                      },
                                                      attrs: {
                                                        disabled: _vm.isSecondEditButtonDisabled(
                                                          key
                                                        ),
                                                        variant: "secondary",
                                                        title:
                                                          "Edit Attachments"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.editAttachments(
                                                            value,
                                                            key
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-edit"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              ![
                                                "cover_page",
                                                "attachments"
                                              ].includes(value.formType)
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-tooltip",
                                                          rawName:
                                                            "v-b-tooltip.hover.viewport",
                                                          modifiers: {
                                                            hover: true,
                                                            viewport: true
                                                          }
                                                        }
                                                      ],
                                                      staticStyle: {
                                                        "border-radius": "5px",
                                                        padding:
                                                          "0px 3px 0px 3px"
                                                      },
                                                      attrs: {
                                                        disabled:
                                                          (_vm.selectedTitleDocs !==
                                                            null &&
                                                            (_vm.editAttachmentsEnabled !==
                                                              key &&
                                                              _vm.editAttachmentsEnabled !==
                                                                null)) ||
                                                          _vm.isSecondEditButtonDisabled(
                                                            key
                                                          ),
                                                        variant: "secondary",
                                                        title: "Add Attachments"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.addAttachments(
                                                            value,
                                                            key
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-floppy-o"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isRotatedDoc
                                        ? _c(
                                            "td",
                                            { staticClass: "result" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    value.insurance_pages &&
                                                      value.insurance_pages.join(
                                                        ", "
                                                      )
                                                  ) +
                                                  "\n                  "
                                              ),
                                              value.insurance_pages &&
                                              value.insurance_pages.join(", ")
                                                ? _c("br")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              value.insurance_pages &&
                                              value.insurance_pages.length > 0
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-tooltip",
                                                          rawName:
                                                            "v-b-tooltip.hover.viewport",
                                                          modifiers: {
                                                            hover: true,
                                                            viewport: true
                                                          }
                                                        }
                                                      ],
                                                      staticStyle: {
                                                        "border-radius": "5px",
                                                        padding:
                                                          "0px 3px 0px 3px"
                                                      },
                                                      attrs: {
                                                        variant: "secondary",
                                                        title:
                                                          "Remove Insurance Card Page"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.removeInsPages(
                                                            value,
                                                            key
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              value.insurance_pages &&
                                              value.insurance_pages.length > 0
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-tooltip",
                                                          rawName:
                                                            "v-b-tooltip.hover.viewport",
                                                          modifiers: {
                                                            hover: true,
                                                            viewport: true
                                                          }
                                                        }
                                                      ],
                                                      staticStyle: {
                                                        "border-radius": "5px",
                                                        padding:
                                                          "0px 3px 0px 3px"
                                                      },
                                                      attrs: {
                                                        disabled: _vm.isSecondEditButtonDisabled(
                                                          key
                                                        ),
                                                        variant: "secondary",
                                                        title:
                                                          "Edit Insurance Card Page"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.editInsPages(
                                                            value,
                                                            key
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-edit"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              ![
                                                "cover_page",
                                                "attachments"
                                              ].includes(value.formType)
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "b-tooltip",
                                                          rawName:
                                                            "v-b-tooltip.hover.viewport",
                                                          modifiers: {
                                                            hover: true,
                                                            viewport: true
                                                          }
                                                        }
                                                      ],
                                                      staticStyle: {
                                                        "border-radius": "5px",
                                                        padding:
                                                          "0px 3px 0px 3px"
                                                      },
                                                      attrs: {
                                                        disabled:
                                                          (_vm.selectedTitleDocs !==
                                                            null &&
                                                            (_vm.editInsCardsEnabled !==
                                                              key &&
                                                              _vm.editInsCardsEnabled !==
                                                                null)) ||
                                                          _vm.isSecondEditButtonDisabled(
                                                            key
                                                          ),
                                                        variant: "secondary",
                                                        title:
                                                          "Save/Add Insurance Card"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.addInsPages(
                                                            value,
                                                            key
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-floppy-o"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "result" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName:
                                                    "v-b-tooltip.hover.viewport",
                                                  modifiers: {
                                                    hover: true,
                                                    viewport: true
                                                  }
                                                }
                                              ],
                                              staticStyle: {
                                                "border-radius": "5px",
                                                padding: "0px 6px 0px 6px"
                                              },
                                              attrs: {
                                                disabled:
                                                  (_vm.selectedTitleDocs !==
                                                    null &&
                                                    _vm.editAttachmentsEnabled !==
                                                      null) ||
                                                  (_vm.selectedTitleDocs !==
                                                    null &&
                                                    _vm.editInsCardsEnabled !==
                                                      null),
                                                variant: "primary",
                                                title: "Edit"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.editPages(value, key)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-edit"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName:
                                                    "v-b-tooltip.hover.viewport",
                                                  modifiers: {
                                                    hover: true,
                                                    viewport: true
                                                  }
                                                }
                                              ],
                                              staticStyle: {
                                                "border-radius": "5px",
                                                padding: "0px 6px 0px 6px"
                                              },
                                              attrs: {
                                                variant: "danger",
                                                title: "Remove"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.removePages(value, key)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-trash"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ],
                        1
                      )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "scrollable-content",
              staticStyle: { overflow: "scroll", "max-height": "120vh" },
              attrs: { sm: "6" }
            },
            [
              _c(
                "Container",
                {
                  attrs: {
                    orientation: "horizontal",
                    "drag-handle-selector": ".column-drag-handle",
                    "drop-placeholder": _vm.upperDropPlaceholderOptions
                  },
                  on: {
                    drop: function($event) {
                      _vm.onColumnDrop($event)
                    },
                    "drag-start": _vm.dragStart
                  }
                },
                _vm._l(_vm.scene.children, function(column) {
                  return _c(
                    "Draggable",
                    { key: column.id },
                    [
                      _c("b-card", [
                        _c(
                          "div",
                          { class: column.props.className },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-column-header d-flex justify-content-between",
                                staticStyle: {
                                  padding: "10px 0.5px",
                                  "background-color": "#a8aeb3"
                                }
                              },
                              [
                                _c("div", { staticClass: "checkbox-padding" }, [
                                  column.name === "Unmatched Pages"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectAllUnmatched,
                                            expression: "selectAllUnmatched"
                                          }
                                        ],
                                        ref: "selectAllUnmatchedClicks",
                                        refInFor: true,
                                        staticStyle: {
                                          transform: "scale(1.1)"
                                        },
                                        attrs: {
                                          type: "checkbox",
                                          id: column.id
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.selectAllUnmatched
                                          )
                                            ? _vm._i(
                                                _vm.selectAllUnmatched,
                                                null
                                              ) > -1
                                            : _vm.selectAllUnmatched
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$a = _vm.selectAllUnmatched,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectAllUnmatched = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectAllUnmatched = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectAllUnmatched = $$c
                                              }
                                            },
                                            function($event) {
                                              _vm.selectAllUnmatchedPages()
                                            }
                                          ]
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  column.name === "Templates"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectAllTemplates,
                                            expression: "selectAllTemplates"
                                          }
                                        ],
                                        ref: "selectAllTemplateClicks",
                                        refInFor: true,
                                        staticStyle: {
                                          transform: "scale(1.1)"
                                        },
                                        attrs: {
                                          type: "checkbox",
                                          id: column.id
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.selectAllTemplates
                                          )
                                            ? _vm._i(
                                                _vm.selectAllTemplates,
                                                null
                                              ) > -1
                                            : _vm.selectAllTemplates
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$a = _vm.selectAllTemplates,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectAllTemplates = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectAllTemplates = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectAllTemplates = $$c
                                              }
                                            },
                                            function($event) {
                                              _vm.selectAllTemplatePages()
                                            }
                                          ]
                                        }
                                      })
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", {
                                    staticClass: "column-drag-handle"
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        column.name === "Templates"
                                          ? "Enrollment Forms"
                                          : column.name
                                      ) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticStyle: { width: "30px" } })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "Container",
                              {
                                staticStyle: {
                                  width: "23.5vw",
                                  height: "900px",
                                  "background-color": "#ebeff3"
                                },
                                attrs: {
                                  "group-name": "col",
                                  "get-child-payload": _vm.getCardPayload(
                                    column.id
                                  ),
                                  "drag-class": "card-ghost",
                                  "drop-class": "card-ghost-drop",
                                  "drop-placeholder": _vm.dropPlaceholderOptions
                                },
                                on: {
                                  drop: function(e) {
                                    return _vm.onCardDrop(column.id, e)
                                  },
                                  "drag-start": function(e) {
                                    return _vm.log("drag start", e)
                                  },
                                  "drag-end": function(e) {
                                    return _vm.log("drag end", e)
                                  }
                                }
                              },
                              _vm._l(column.children, function(card) {
                                return _c(
                                  "Draggable",
                                  {
                                    key: card.id,
                                    staticStyle: { padding: "1px" }
                                  },
                                  [
                                    (_vm.isEditedDoc
                                    ? card.data.form &&
                                      card.data.form.isEdited === true
                                    : card.data.form &&
                                      card.data.form.process !== true)
                                      ? _c("div", [
                                          card.data.found && card.data.form
                                            ? _c(
                                                "div",
                                                {
                                                  class: card.props.className,
                                                  style:
                                                    card.data.form.process ==
                                                    true
                                                      ? "border: 2px solid green"
                                                      : "border: none;"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-between"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "checkbox-padding"
                                                        },
                                                        [
                                                          !card.data.form
                                                            .isEdited
                                                            ? _c("input", {
                                                                ref:
                                                                  "CheckboxClicks",
                                                                refInFor: true,
                                                                attrs: {
                                                                  type:
                                                                    "checkbox",
                                                                  id: card.id
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.updateDisableCheckBox()
                                                                  }
                                                                }
                                                              })
                                                            : _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.editedCheckedBoxes,
                                                                    expression:
                                                                      "editedCheckedBoxes"
                                                                  }
                                                                ],
                                                                ref:
                                                                  "CheckboxClicks",
                                                                refInFor: true,
                                                                attrs: {
                                                                  type:
                                                                    "checkbox",
                                                                  id: card.id
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    card.data
                                                                      .form.id,
                                                                  checked: Array.isArray(
                                                                    _vm.editedCheckedBoxes
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm.editedCheckedBoxes,
                                                                        card
                                                                          .data
                                                                          .form
                                                                          .id
                                                                      ) > -1
                                                                    : _vm.editedCheckedBoxes
                                                                },
                                                                on: {
                                                                  change: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      var $$a =
                                                                          _vm.editedCheckedBoxes,
                                                                        $$el =
                                                                          $event.target,
                                                                        $$c = $$el.checked
                                                                          ? true
                                                                          : false
                                                                      if (
                                                                        Array.isArray(
                                                                          $$a
                                                                        )
                                                                      ) {
                                                                        var $$v =
                                                                            card
                                                                              .data
                                                                              .form
                                                                              .id,
                                                                          $$i = _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                        if (
                                                                          $$el.checked
                                                                        ) {
                                                                          $$i <
                                                                            0 &&
                                                                            (_vm.editedCheckedBoxes = $$a.concat(
                                                                              [
                                                                                $$v
                                                                              ]
                                                                            ))
                                                                        } else {
                                                                          $$i >
                                                                            -1 &&
                                                                            (_vm.editedCheckedBoxes = $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              ))
                                                                        }
                                                                      } else {
                                                                        _vm.editedCheckedBoxes = $$c
                                                                      }
                                                                    },
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      _vm.updateDisableCheckBox()
                                                                    }
                                                                  ]
                                                                }
                                                              })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("p", [
                                                        _vm._v(
                                                          "Page: " +
                                                            _vm._s(
                                                              card.data.form
                                                                .original_page_no
                                                            )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("img", {
                                                    staticClass: "card-img",
                                                    style: {
                                                      transform:
                                                        "rotate(" +
                                                        card.data.form
                                                          .rotation +
                                                        "deg)"
                                                    },
                                                    attrs: {
                                                      onContextMenu:
                                                        "return false;",
                                                      width: "100",
                                                      height: "300",
                                                      src: card.data.form
                                                        ? _vm.axios.defaults.baseURL.replace(
                                                            "/api",
                                                            ""
                                                          ) +
                                                          card.data.form
                                                            .image_thumbnail
                                                        : "",
                                                      id:
                                                        card.data.form.id +
                                                        card.data.form
                                                          .original_title
                                                    },
                                                    on: {
                                                      load: function($event) {
                                                        _vm.loadingImage(
                                                          $event,
                                                          card.data.form
                                                        )
                                                      },
                                                      click: function($event) {
                                                        _vm.viewFullImage(
                                                          card.data.form,
                                                          column.name
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            : _c("div", [
                                                _c("img", {
                                                  staticClass: "card-img",
                                                  attrs: {
                                                    onContextMenu:
                                                      "return false;",
                                                    width: "100",
                                                    height: "300"
                                                  }
                                                })
                                              ])
                                        ])
                                      : _c("div", [
                                          _c("img", {
                                            staticClass: "card-img",
                                            attrs: {
                                              onContextMenu: "return false;",
                                              width: "100",
                                              height: "239"
                                            }
                                          })
                                        ])
                                  ]
                                )
                              })
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                })
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "viewFullImage",
          staticClass: "modal-primary",
          attrs: {
            size: "lg",
            centered: "",
            id: "hideModal",
            "no-close-on-esc": "",
            "hide-header-close": "",
            "no-close-on-backdrop": "",
            scrollable: ""
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "modal-header" }, slot: "modal-header" },
            [
              _c("label", [_vm._v(_vm._s(_vm.selectedImage.title))]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.viewport",
                      modifiers: { hover: true, viewport: true }
                    }
                  ],
                  staticStyle: { padding: "4px 8px", "border-radius": "0px" },
                  attrs: {
                    size: "sm",
                    variant: "dark",
                    title: _vm.$t("FORMS.ROTATE_LEFT")
                  },
                  on: {
                    click: function($event) {
                      _vm.imageRotateLeft()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-undo" })]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.viewport",
                      modifiers: { hover: true, viewport: true }
                    }
                  ],
                  staticStyle: { padding: "4px 8px", "border-radius": "0px" },
                  attrs: {
                    size: "sm",
                    variant: "dark",
                    title: _vm.$t("FORMS.ROTATE_RIGHT")
                  },
                  on: {
                    click: function($event) {
                      _vm.imageRotateRight()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-repeat" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: 12 } }, [
                _c(
                  "div",
                  { staticStyle: { height: "75vh", "overflow-y": "auto" } },
                  [
                    _vm.modelOpen
                      ? _c("img", {
                          staticClass: "card-img",
                          staticStyle: { width: "80%" },
                          style: { transform: "rotate(" + this.angle + "deg)" },
                          attrs: {
                            onContextMenu: "return false;",
                            src: _vm.selectedImage
                              ? _vm.axios.defaults.baseURL.replace("/api", "") +
                                _vm.selectedImage.image_url
                              : "",
                            id: _vm.selectedImage.id
                          },
                          on: {
                            load: function($event) {
                              _vm.loadingImage($event, _vm.selectedImage)
                            }
                          }
                        })
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.saveRotationTemplateImage()
                    }
                  }
                },
                [_vm._v(" Save ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.closeRotationTemplateImage()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "rejectFormDoc",
          attrs: {
            "hide-header-close": "",
            title: "Reject Form",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            { staticClass: "mt-3" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/img/exclamation.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Do you want to reject this document?")])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "danger" },
                  on: { click: _vm.rejectForm }
                },
                [_vm._v(" Confirm ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.hideRejectFormDocModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CANCEL")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "unmatchedPagesAlert",
          attrs: {
            "hide-header-close": "",
            title: "Alert",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            { staticClass: "mt-3" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("h5", [
                      _vm._v(
                        "The form cannot be processed from the unmatched pages panel, so please drag the image from the Unmatched Pages and drop it into the Enrollment Forms Panel. Then, select the appropriate checkbox and save."
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "dark" },
                  on: {
                    click: function($event) {
                      _vm.$refs.unmatchedPagesAlert.hide()
                    }
                  }
                },
                [_vm._v(" Ok ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "rotatePagesAlert",
          attrs: {
            "hide-header-close": "",
            title: "Alert",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            { staticClass: "mt-3" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("h5", [
                      _vm._v("Kindly choose at least one form to rotate.")
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "dark" },
                  on: {
                    click: function($event) {
                      _vm.$refs.rotatePagesAlert.hide()
                    }
                  }
                },
                [_vm._v(" Ok ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "multipleInsAlert",
          attrs: {
            "hide-header-close": "",
            title: "Alert",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            { staticClass: "mt-3" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("h5", [
                      _vm._v(
                        "Please note that only one insurance card can be processed with the start form. Kindly verify your selection and choose the correct insurance card."
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "dark" },
                  on: {
                    click: function($event) {
                      _vm.$refs.multipleInsAlert.hide()
                    }
                  }
                },
                [_vm._v(" Ok ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3673dea5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3673dea5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/forms/modifyProcessType.vue
// module id = 1192
// module chunks = 2